import ModulePreview from './ModulePreview';

export default ModulePreview;
